import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

const Event = ({ eventData }) => {
  const { id, attributes } = eventData;
  const { address, listImage, title, startDate, ticketPrice } = attributes;
  const apiBase = process.env.REACT_APP_BASE_URL || "";
  const imgUrl = listImage?.data?.attributes?.url;
  const cityName = address?.city?.data?.attributes?.name || "";

  return (
    <article className="hn-card">
      <div className="hn-card-thumb" style={{ position: "relative" }}>
        <Link to={`/events/${id}`}>
          <img
            src={imgUrl ? `${apiBase}${imgUrl}` : "https://via.placeholder.com/400x250?text=Event"}
            alt={title}
            loading="lazy"
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          />
        </Link>
        <span className="hn-card-badge">
          {ticketPrice === 0 ? "Free" : `N$ ${ticketPrice}`}
        </span>
      </div>
      <div className="hn-card-body">
        <div className="hn-card-meta">
          <span><i className="bi bi-calendar2-week" /> {moment(startDate).format("DD MMM YYYY")}</span>
          {cityName && <span><i className="bi bi-geo-alt" /> {cityName}</span>}
        </div>
        <h3 className="hn-card-title">
          <Link to={`/events/${id}`}>
            {title}
          </Link>
        </h3>
        <Link to={`/events/${id}`} className="hn-card-cta">
          View details <i className="bi bi-arrow-right" />
        </Link>
      </div>
    </article>
  );
};

export default Event;
